export default __webpack_public_path__ + "static/media/07.ef7ebb2d.jpg";